<script lang="ts">import { ComponentType, DESKTOP_BREAKPOINT_GLOBAL_NAV } from '../../../js-v2/constants';
import { mobileNavStateStore } from '../../../js-v2/stores/mobile-nav-stores';
import DesktopNav from './DesktopNav/DesktopNav.svelte';
import MobileNav from './MobileNav/MobileNav.svelte';
const { id = '', homeLink = undefined, primaryNavItems = [], secondaryNavItems = [], cart = undefined, primaryCtaButton = undefined, secondaryCtaButton = undefined, ctaButtonStyleV1 = false, } = $props();
let innerWidth = $state(undefined);
const desktopMode = $derived(innerWidth === undefined ? null : innerWidth >= DESKTOP_BREAKPOINT_GLOBAL_NAV);
// Close mobile nav when switching from mobile to desktop
$effect(() => {
    if (desktopMode && $mobileNavStateStore.isOpen) {
        mobileNavStateStore.toggle();
    }
});
</script>

<svelte:window bind:innerWidth />

<div
  class="GlobalNav"
  data-global-nav-v2
  data-component-type={ComponentType.MAIN_NAVIGATION}
  data-nav-device-type={desktopMode ? 'Desktop' : 'Mobile'}
>
  <DesktopNav
    {id}
    {homeLink}
    {primaryNavItems}
    {secondaryNavItems}
    {cart}
    {primaryCtaButton}
    {secondaryCtaButton}
    {ctaButtonStyleV1}
  />
  <MobileNav {id} {homeLink} {primaryNavItems} {secondaryNavItems} {cart} />
</div>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/</style>
